<template>
    <div>
        <div v-if="delete_loader" class="checkoutLoader">
            <div class="LoaderPlacement">
                <div class="digi-table-loader">
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                </div>
            </div>
        </div>
        <div class="d-flex justify-content-between align-items-center mb-3">
            <ul class="d-flex align-items-center pl-4 mb-0">
                <li class="d-flex align-items-center employee_list_active">
                    <span class="list-text highlighted">Configure QR Code</span>
                </li>
            </ul>
            <div class="d-flex align-items-center">
                <button class="btn btn-create btn-smm  " style="height:35px !important"
                    @click="CreateQrCodeModal">
                    <i class="icon icon-plus-circle create-icon fs-20"></i>
                    <span class="ml-1  fs-14 " style="color: #388e3c;"> New </span>
                </button>
                <button class="btn btn-print btn-smm ml-3" style="height:35px !important"
                    @click="PrintAllQrCodeModal">
                    <i class="icon icon-printer text-white fs-16"
                        style="color: #0e315f !important; position: relative; top: -1px;"></i>
                    <span class="ml-1 hidden-sm-down fs-13" style="color: #0e315f !important;"> QR Code </span>
                </button>
            </div>
        </div>
        <div class="py-3 position-content-main mt-4"
            style="height: auto !important;background: #f0ddb7!important; border-radius: 10px;">
            <div class="page-layout blank">
                <div class="pb-2" style="min-height:fit-content;">
                    <div class="d-flex flex-wrap justify-content-between" style="gap:1rem">
                        <div class="breadcrumbnewtheme pb-3">

                            <div class="pre gap-0p5 fw-500 text-black">
                                Configure QR code
                            </div>
                            <span style="color:#b2bec3">/</span>
                            <span class="curr gap-0p5 fw-500">
                                List View
                            </span>
                        </div>
                        <div class="d-flex align-items-center justify-content-between mb-4" style="gap:.5rem">
                            <button @click="firstPage()" :disabled="skip == 0" class="mt-1 pointer pagination-list">
                                <el-tooltip class="item" effect="dark" content="First Page" placement="top">
                                    <!-- <i class="icon-chevron-double-left text-black"></i> -->
                            <img src="/static/images/new-theme2024/arrow-left.svg" style=" z-index: 10">

                                </el-tooltip>
                            </button>
                            <button @click="previousPage()" :disabled="skip == 0"
                                class="pagination-list-single mt-1 ml-2 pointer">
                                <el-tooltip class="item" effect="dark" content="Previous Page" placement="top">
                                    <!-- <i class="icon icon-chevron-left text-black"></i> -->
                            <img src="/static/images/new-theme2024/arrow-left-single.svg" style=" z-index: 10">

                                </el-tooltip>
                            </button>
                            <span class="px-2 fw-500 fs-14 mt-1 text-black">Showing {{getSkipCount}} -
                                {{total>skip+limit?skip+limit:total}} of {{total}}</span>
                            <button @click="nextPage()" :disabled="skip_temp >= total"
                                class="pagination-list-single mt-1 mr-2 pointer">
                                <el-tooltip class="item" effect="dark" content="Next Page" placement="top">
                                    <!-- <i class="icon icon-chevron-right text-black"></i> -->
                            <img src="/static/images/new-theme2024/arrow-right-single.svg" style=" z-index: 10">

                                </el-tooltip>
                            </button>
                            <button @click="lastPage()" class="mt-1 pointer pagination-list"
                                :disabled="temp_total == total">
                                <el-tooltip class="item" effect="dark" content="Last Page" placement="top">
                                    <!-- <i class="icon-chevron-double-right text-black"></i> -->
                            <img src="/static/images/new-theme2024/arrow-right.svg" style=" z-index: 10">

                                </el-tooltip>
                            </button>
                        </div>
                    </div>
                    <div class="vendor-list height-fit-content" style="background-color: #f6f8fc !important;">
                        <div class="p-0">
                            <div>
                                <div class="row" style="background: #f0ddb7;">
                                    <div class="col-lg-4 col-md-4 col-sm-6 left-list" style="margin-right: -10px;">
                                        <div class="mb-3 scroll-new view-box" style="background: white;">
                                            <div v-if="ajax_call_in_progress" class="d-flex align-items-center justify-content-center h-100 bg-white" style="height: 100vh !important;">
                                                <img src="/static/images/new-theme2024/20 card.gif" width="100" alt="">
                                            </div>
                                            <div v-else-if="list_data.length == 0" class="d-flex fw-600 fs-15 align-items-center justify-content-center h-100 bg-white" style="height: 100vh !important;">
                                                No Data Found
                                            </div>
                                            <div v-else v-for="(data, index) in list_data" :key="index+'list_data'">
                                                <div class="list-box px-4 py-2 pointer"
                                                    :class="{ 'list-light': index % 2, 'highlight': list_id_index == index }"
                                                    @click="passData(data, index)">
                                                    <div class="d-flex flex-wrap justify-content-between">
                                                        <span class="fs-14  font-weight-bold text-black">Facility
                                                            Name: {{data.facility_name || '-'}}</span>
                                                    </div>
                                                    <div class="d-flex flex-wrap justify-content-between mt-2">
                                                        <span class="text-black fw-600"
                                                            style="white-space: nowrap;overflow: hidden;text-overflow: ellipsis;"
                                                            :title="data.location">
                                                            Location: {{data.location || "-"}}</span>
                                                    </div>
                                                    <div class="d-flex justify-content-between mt-2">
                                                        <span class="text-black fw-500 "
                                                            style="width: 175px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis; ">Activity:
                                                            <el-switch class="ml-4" v-model="data.status"
                                                                @change="changeStatus($event, data)"></el-switch>
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-lg-8 col-md-8 col-sm-6 view-box scroll-new"
                                        style="overflow-y: auto !important;height: max-content !important; background-color: white !important;">
                                        <div class="page-layout blank contacts-manage pt-3"
                                            style="margin-left: 0px !important;margin-right: 0px !important;">
                                            <div class="pb-10">
                                                <div v-if="ajax_call_in_progress" class="d-flex align-items-center justify-content-center h-100 bg-white" style="height: 100vh !important;">
                                                    <img src="/static/images/new-theme2024/20 card.gif" width="100" alt="">
                                                </div>
                                                <div v-else-if="list_data.length == 0" class="d-flex fw-600 fs-15 align-items-center justify-content-center h-100 bg-white" style="height: 100vh !important;">
                                                    No Data Selected
                                                </div>
                                                <div v-else class="vendor-list br-t-l-r mt-2" id="printId">
                                                    <div class="mb-3">
                                                        <div
                                                            class=" d-flex align-items-center justify-content-between  ">
                                                            <div>
                                                                <span v-if="list_data.length > 0" class=" font-weight-bold pl-1 black-border-bottom">
                                                                    {{ list_data[list_id_index].facility_name || '-'}}
                                                                    Details</span>
                                                                   
                                                            </div>
                                                            <div>
                                                                <button class="print-button pointer"
                                                                    style="background-color: #00448b; border-radius: 4px;"
                                                                    @click="ViewQrCode('print')">
                                                                    <img src="https://cdn.digicollect.com/cdn/scmnew/images/scm/printer.svg"
                                                                        style="width:70%; margin-top:-7px;"></button>
                                                                <button class="edit-button pointer ml-2"
                                                                    style="background-color: #ef3c36; border-radius: 4px;"
                                                                    @click="deleteQrCodeConfirm">
                                                                    <i
                                                                        class="el-tooltip icon ri-delete-bin-4-fill fs-20 text-white  icon-custom-style item"></i></button>
                                                            </div>
                                                        </div>
                                                        <div class="header-detail-view-new mt-5 p-3">
                                                            <div>
                                                                <span class=" pl-1 ">Details of the QR Code:</span>
                                                            </div>
                                                        </div>
                                                        <div class="d-flex justify-content-between align-items-center">
                                                            <div class="row m-0 mt-3">
                                                                <div class="col-lg-12 col-md-6 col-sm-12 d-flex mb-2">
                                                                    <div>
                                                                        <p class="text-black pr-2 fw-500">Facility Name:
                                                                        </p>
                                                                    </div>
                                                                    <div>
                                                                        <p v-if="list_data.length > 0" class="text-black fw-500">
                                                                            {{ list_data[list_id_index].facility_name || '-'}}
                                                                        </p>
                                                                    </div>
                                                                </div>
                                                                <div class="col-lg-12 col-md-6 col-sm-12 d-flex mb-2">
                                                                    <div>
                                                                        <p class="text-black pr-11 fw-500">Location:</p>
                                                                    </div>
                                                                    <div>
                                                                        <p v-if="list_data.length > 0" class="text-black fw-500">
                                                                            {{ list_data[list_id_index].location || '-' }}
                                                                        </p>
                                                                    </div>
                                                                </div>
                                                                <div class="col-lg-12 col-md-6 col-sm-12 d-flex mb-2">
                                                                    <div>
                                                                        <p class="text-black pr-11 fw-500">Activate:
                                                                        </p>
                                                                    </div>
                                                                    <div>
                                                                        <p v-if="list_data.length > 0" class="text-black fw-500">
                                                                            <el-switch
                                                                                v-model="list_data[list_id_index].status"
                                                                                @change="changeStatus($event, list_data[list_id_index])">
                                                                            </el-switch>
                                                                        </p>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div>
                                                                <div class="">
                                                                    <qr-code :text="qr_cde" size="80" color="#0d84f2"></qr-code>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- <div>
            <div class="row">
                <div class="col-md-12">
                        <div class="float-right">
                            <span class="text-new-blue fs-14 pointer d-block" @click="CreateQrCodeModal">
                                + Add New QR Code
                            </span>
                        </div>
                </div>
            </div>
        </div> -->
        <add-new-qr-code v-if="qrcodemodal" @saveSuccess="saveSuccess" @hide-add-qrcode-modal="HideAddNewQrCodeModal"
            modal_name="AddQrCodeModal"></add-new-qr-code>
        <view-qr-code v-if="viewqrcode" :qr_code_type="qr_code_type" @hide-view-qr-code="HideViewQrCode"
            :qr_cde="qr_cde" :qr_code_name="qr_code_name" modal_name="ViewQrCode"></view-qr-code>
        <print-all-qr-code v-if="printallqrcode" @hide-print-all-qr-code="HidePrintAllQrCode"
            :qr_code_data="qr_code_data" modal_name="PrintAllQrCodeModal"></print-all-qr-code>
        <sweet-modal ref="success_modal" icon="success">{{success_msg}}</sweet-modal>
        <sweet-modal ref="warning_modal" icon="warning">{{warning_msg}}</sweet-modal>
    </div>
</template>

<script>
    import {
        SweetModal
    } from 'sweet-modal-vue';
    import AddNewQrCode from './AddNewQrCode'
    import ViewQrCode from './ViewQrCode'
    import PrintAllQrCode from './PrintAllQrCode'
    import facility_mgmt from '../../mixins/facility_mgmt';
    import {EventBus} from '../../eventBus/nav-bar-event'
    import global from '../../global';
    import Swal from 'sweetalert2';
    import VueQRCodeComponent from 'vue-qr-generator'
    export default ({
        mixins: [facility_mgmt],
        data() {
            return {
                activate: false,
                ajax_call_in_progress: false,
                qrcodemodal: false,
                viewqrcode: false,
                printallqrcode: false,
                list_data: [{
                    facility_name: '',
                    location: '',
                    status: false,
                }],
                success_msg: '',
                warning_msg: '',
                qr_cde: '',
                qr_code_type: '',
                qr_code_name: '',
                qr_code_data: [],
                skip: 0,
                limit: 10,
                total: 0,
                temp_total: 0,
                search_key: '',
                pageLimit: [],
                skip_temp: 0,
                count: 0,
                data_loader: false,
                pageLimit: [],
                list_id_index: 0,
            }
        },
        components: {
            AddNewQrCode,
            ViewQrCode,
            PrintAllQrCode,
            SweetModal,
            Swal,
            VueQRCodeComponent
        },
        methods: {
            passData(data, index) {
                this.list_id_index = index
                this.qr_cde = global.HELP_URL + '/facilitymanagement/securityconcern/create?facility_id=' + this
                    .list_data[this.list_id_index].facility_id;
            },
            CreateQrCodeModal() {
                EventBus.$emit('ZindexChangeStart')
                this.qrcodemodal = true
                setTimeout(() => {
                    this.$modal.show('AddQrCodeModal')
                }, 500);
            },
            HideAddNewQrCodeModal() {
                EventBus.$emit('ZindexChangeEnd')
                this.qrcodemodal = false
                setTimeout(() => {
                    this.$modal.hide('AddQrCodeModal')
                }, 500);
            },
            saveSuccess() {
                this.fetchListData();
            },
            ViewQrCode(type) {
                this.qr_code_type = type;
                this.qr_code_name = this.list_data[this.list_id_index].location;
                this.viewqrcode = true
                this.qr_cde = global.HELP_URL + '/facilitymanagement/securityconcern/create?facility_id=' + this.list_data[this.list_id_index].facility_id;
                // EventBus.$emit('ZindexChangeStart')
                setTimeout(() => {
                    this.$modal.show('ViewQrCode')
                }, 500)
            },
            HideViewQrCode() {
                EventBus.$emit('ZindexChangeEnd')
                this.viewqrcode = false
            },
            PrintAllQrCodeModal() {
                EventBus.$emit('ZindexChangeStart')
                this.qr_code_data = [];
                this.list_data.forEach((element, index) => {
                    if (element.status == true) {
                        this.qr_code_data.push({
                            link: global.HELP_URL +
                                '/facilitymanagement/securityconcern/create?facility_id=' + element
                                .facility_id,
                            qr_code: element.location,
                        })
                    }
                });
                this.printallqrcode = true
                setTimeout(() => {
                    this.$modal.show('PrintAllQrCodeModal')
                }, 500)
            },
            HidePrintAllQrCode() {
                EventBus.$emit('ZindexChangeEnd')
                this.printallqrcode = false
            },
            firstPage() {
                this.temp_total = 0
                this.skip = 0
                this.limit = 10
                this.list_data = []
                this.fetchListData()
            },
            lastPage() {
                this.skip_temp = 0
                this.skip = 0
                this.temp_total = this.total
                let no_of_pages = Math.ceil(this.total / this.limit)
                this.skip_temp = (no_of_pages * this.limit) - this.limit
                if (this.skip_temp >= this.total) {
                    return;
                }
                this.skip = this.skip_temp
                this.fetchListData();
            },
            nextPage() {
                this.skip_temp = this.skip + this.limit > this.total ? this.total : this.skip + this.limit;
                if (this.skip_temp >= this.total) {
                    return;
                }
                this.skip = this.skip_temp;
                this.fetchListData();
            },
            previousPage() {
                this.skip_temp = 0
                this.temp_total = 0
                if (this.skip == 0) {
                    return;
                }
                this.skip = this.skip - this.limit <= 0 ? 0 : this.skip - this.limit;
                this.fetchListData();
            },
            async fetchListData() {
                this.ajax_call_in_progress = true;
                try {
                    let params = {
                        skip: this.skip,
                        limit: this.limit,
                        search_key: this.search_key.trim(),
                    };
                    let response = await this.getQrCodeList(params);
                    this.list_data = [];
                    this.list_data = response.response.qr_code_list;
                    if(response.response.qr_code_list != 0){
                        this.passData(this.list_data[0], 0)
                    }
                    this.total = response.response.count;
                    this.ajax_call_in_progress = false;
                } catch (error) {
                    this.warning_msg = error;
                    this.$refs.warning_modal.open();
                    setTimeout(() => {
                        this.$refs.warning_modal.close();
                    }, 3000);
                    this.ajax_call_in_progress = false;
                }
            },
            deleteQrCodeConfirm() {
                Swal.fire({
                    title: 'Alert',
                    text: "Are you sure want to delete ?",
                    type: 'warning',
                    icon: 'warning',
                    showCloseButton: true,
                    showCancelButton: true,
                    confirmButtonColor: '#00448b',
                    confirmButtonText: 'YES',
                    cancelButtonText: 'NO'
                }).then((result) => {
                    if (result.isConfirmed == true) {
                        this.deleteQrCode()
                    }
                })
            },
            async deleteQrCode() {
                this.delete_loader = true
                try {
                    let params = {
                        qr_code_id: this.list_data[this.list_id_index]._id,
                    };
                    let response = await this.deleteQrCodeById(params);
                    this.success_msg = response.response.success_message
                    this.$refs.success_modal.open();
                    setTimeout(() => {
                        this.delete_loader = false
                        this.$refs.success_modal.close();
                        this.fetchListData();
                    }, 3000);
                } catch (error) {
                    this.delete_loader = false
                    this.warning_msg = error;
                    this.$refs.warning_modal.open();
                }
            },
            async changeStatus(event, data) {
                try {
                    let params = {
                        qr_code_id: data._id,
                        status: event
                    };
                    let response = await this.updateQrCode(params);
                    this.success_msg = response.response.success_message
                    this.$refs.success_modal.open();
                    setTimeout(() => {
                        this.$refs.success_modal.close();
                        this.fetchListData();
                    }, 3000);
                } catch (error) {
                    this.warning_msg = error;
                    this.$refs.warning_modal.open();
                    setTimeout(() => {
                        this.$refs.warning_modal.close();
                    }, 3000);
                }
            }
        },
        mounted() {
            for (let i = 10; i <= 50; i += 10) {
                this.pageLimit.push(i);
            }
            this.fetchListData();
        },
        watch: {
            limit: function () {
                this.fetchListData();
            }
        },
        computed: {
            getSkipCount() {
                if (this.total == 0) {
                    return 0
                } else {
                    let skip_count = this.skip > this.total ? this.total : this.skip + 1;
                    return skip_count;
                }
            },
        }
    })
</script>

<style scoped>
.el-switch__core {
    margin: 0;
    display: inline-block;
    width: 40px;
    height: 20px;
    border: 1px solid #130e0e !important;
    outline: 0;
    border-radius: 10px;
    box-sizing: border-box;
    background: #130e0e !important;
    cursor: pointer;
    transition: border-color .3s,background-color .3s;
}
    .list-text {
        font-size: 17px;
        font-weight: 500;
        color: #000;
    }

    .list-text-count {
        font-size: 14px;
        font-weight: 500;
        font-weight: 600;
        color: rgba(54, 54, 54, 0.61);
    }

    .btn-print {
        border-radius: 18px !important;
        /* background: #ab33ea; */
        color: #0e315f;
        border: 2px solid #0e315f;
        background: white;
    }

    .color-purple {
        background: #ab33ea;
    }

    .color-blue {
        color: #005dae;
    }

    .table-large-text {
        max-width: 280px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .ht-100px {
        height: 100px;
    }

    .btn-shift {
        border: 2px solid #038b62 !important;
        background: white;
        border-radius: 5px;
        color: #038b62;
    }

    table td {
        text-align: left;
    }

    .ht-100px {
        height: 100px
    }
    .btn-new-call {
        background-color: #03855d !important;
        color: white;
        border-radius: 5px;
    }

    .list-light {
        width: 100%;
        object-fit: contain;
        border-radius: 5px;
        box-shadow: 0 1.5px 3px 0 rgba(0, 0, 0, 0.16);
        border: solid 0.5px #f3f6fb;
        background-color: #ffffff;
    }
    .highlight {
        background-color: #d5e2fa !important;
    }

    @media (max-width: 1100px) {
        .hide-line {
            display: none;
        }
    }

    .edit-button {
        background-color: #fff;
        height: 32px !important;
        width: 40px;
        line-height: 39px !important;
        border-radius: 4px;
    }
    .print-button{
        background-color: #fff;
        height: 32px !important;
        width: 40px;
        line-height: 36px !important;
        border-radius: 4px;
    }

    .box-blue-header {
        border-radius: 3px;
    }

    .box-blue-header-parent {
        background: #005dae;
        position: relative;
        top: -1px;
        margin-left: -1px;
    }

    .ticket_count {
        background-color: #7b7f97;
        border-radius: 20px;
        font-size: 10px;
        font-weight: 600 !important;
        color: #ffffff;
        margin-left: 4px;
        padding: 0px 6px;
    }

    .count-ticket {
        background-color: #1b57ad;
        border-radius: 20px;
        font-size: 10px;
        font-weight: 600 !important;
        color: #ffffff;
        margin-left: 4px;
        padding: 0px 6px;
    }

    .ticket_tab {
        background-color: #005dae;
    }

    .activeColor {
        background-color: #005dae;
        color: #ffffff;
    }

    .email-buttons {
        display: none;
    }

    @media screen and (max-width: 991px) {
        .mob-list-scroll {
            min-width: 991px;
        }
    }

    .btn-success {
        background-color: #25bb83 !important;
    }

    .ticket-list-button {
        color: #363636;
        border-radius: 6px !important;
        box-shadow: none !important;
        font-weight: 600;
        background-color: #e4e4e4;
        width: 230px;
    }
    .view-box {
        border: 1px solid #a5a5a5;
        border-radius: 6px
    }

    .scm-filters {
        font-family: "Poppins", "Helvetica Neue", sans-serif !important;
        height: 500px;
        overflow: auto;
        max-width: 768px;
        top: 100px;
        background: #e6ecff !important;
    }

    .overflow-visible {
        overflow: scroll !important;
    }
    .col-small-left {
        width: 200px;
    }

    .col-small-right {
        position: relative;
        width: 700px;
    }

    .left-list {
        height: max-content !important;
    }

    @media (max-width: 900px) {
        .scroll-news {
            min-width: 900px;
            overflow-x: scroll !important;
        }
    }

    @media (max-width: 580px) {
        .vendor-list {
            height: 100% !important;
        }
    }

    .hor-line {
        width: 2px;
        height: 30px;
        background-color: #1b57ad;
    }

    .filter-box {
        width: 200px;
        height: 30px;
        padding: 2px 3.3px 1.5px 6.5px;
        border: solid 0.5px #363636;
        background-color: #fff;
    }

    .width-fit-content {
        width: fit-content
    }

    .fs-18 {
        font-size: 18px;
    }

    .whitespace-nowrap {
        white-space: nowrap;
    }

    .dropbtn {
        background-color: #fff;
        cursor: pointer;
        margin-top: -5px;
        border-radius: 5px;
        line-height: 33px;
    }

    .res-width {
        min-width: 60%
    }

    .ticket_list_number-selected {
        background-color: #00448b !important;
        color: #fff !important;
    }

    .ticket_list_number-selected .li_span {
        color: #fff !important
    }

    .ticket_list_number-selected i {
        color: #fff !important;
        border: 1px solid #fff !important;
    }

    .ticket_list_number-selected i.no-border {
        border: none !important;
    }

    @media screen and (max-width:1347px) {
        .res-width {
            min-width: 75%
        }
    }

    @media screen and (max-width:1011px) {
        .res-width {
            min-width: 100%;
            flex-wrap: wrap
        }
    }


    .dropdown {
        position: relative;
        display: inline-block;
    }

    .dropdown-content {
        display: none;
        position: absolute;
        background-color: #fff;
        box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
        border-radius: 5px;
        z-index: 1;
        right: 0px;
        top: 32px;
    }

    .dropdown-content a {
        color: black;
        padding: 12px 16px;
        text-decoration: none;
        display: block;
    }

    .dropdown-content a:not([href]):not([tabindex]).tabbed {
        width: 100%;
        vertical-align: middle;
    }

    .dropdown-content a:not([href]):not([tabindex]).tabbed:hover {
        background-color: #eee;
    }

    .dropdown:hover .dropdown-content {
        display: block;
    }

    .height-fit-content {
        height: fit-content
    }
    .btn-print {
        background-color: #fff !important;
        color: #0e315f;
        border: 1px solid #0e315f !important;
        border-radius: 4px !important;
        box-shadow: inset 0 1.5px 3px 0 rgba(0, 0, 0, 0.16) !important;
    }

    .search_input {
        padding: 8px 9.4px 6.5px 33.4px;
        border-radius: 24px;
        background-color: #fff;
        border: 1px solid rgba(103, 103, 103, 0.84);
        border-radius: 18px;
    }

    .align-position {
        position: absolute;
        left: 10px;
        top: 7px;
        color: rgba(103, 103, 103, 0.84);
    }

    .search-bar {
        margin: 0 30px 0 30px;
    }

    .add-btn {
        margin-right: 24px;
        height: 34px;
    }

    .ht-100px {
        height: 100px;
    }

    .w-15 {
        width: 15% !important
    }

    .w-1 {
        width: 1% !important;
        min-width: 250px !important
    }

    .table-content-data tr th {
        text-transform: capitalize;
        color: #00448b;
        background-color: #e8e9ec;
    }

    .text-white {
        color: #fff !important;
    }

    .text-green {
        color: #038b62 !important;
    }

    .breadcrumbnewtheme {
        display: flex;
        align-items: center;
        gap: 1rem;
    }

    .breadcrumbnewtheme div {
        color: #00448b;
    }
    .fs-2rem {
        font-size: 2rem;
    }

    .position-content-main {
        border-radius: 14px;
        background-color: #f0ddb7;
    }

    .header-color {
        color: #4e4e4e !important;
    }
</style>